//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import passageUserManager from "@/Manager/09.Cm/PassageUserManager";
import memberUserManager from "@/Manager/02.Mms/MemberUserManager";

export default {
  data() {
    return {
      PassageUserList: [
        {
          Name: "导购工作台",
          Label: "导购编号",
          Placeholder: "请输入导购编号",

          SystemCode: "SG111901",

          HomeUrl: "/YslGms",
          WorkBenchUrl: "/YslGms/WorkBench",
          BindWechatUrl: "/YslGms/PassageUser/BindWechat"
        },
        
        {
          Name: "门店工作台",
          Label: "门店工作台",
          Placeholder: "请输入店主编号",

          SystemCode: "SZ053219",

          HomeUrl: "/YslSms",
          WorkBenchUrl: "/YslSms/WorkBench",
          BindWechatUrl: "/YslSms/PassageUser/BindWechat"
        },
        
        {
          Name: "经销商工作台",
          Label: "经销工作台",
          Placeholder: "请输入经销商编号",

          SystemCode: "U053220",

          HomeUrl: "/YslDms",
          WorkBenchUrl: "/YslDms/WorkBench",
          BindWechatUrl: "/YslDms/PassageUser/BindWechat"
        },
        {
          Name: "办事处经理",
          Label: "办事处经理",
          Placeholder: "请输入办事处经理编号",

          SystemCode: "U053222",

          HomeUrl: "/YslCm",
          WorkBenchUrl: "/YslCm/SalesOffice/WorkBench",
          BindWechatUrl: "/YslCm/PassageUser/BindWechat"
        },
        {
          Name: "营业部经理",
          Label: "营业部经理",
          Placeholder: "营业部经理编号",

          SystemCode: "U053223",

          HomeUrl: "/YslCm",
          WorkBenchUrl: "/YslCm/SalesDept/WorkBench",
          BindWechatUrl: "/YslCm/PassageUser/BindWechat"
        },
        {
          Name: "销售大区",
          Label: "销售大区",
          Placeholder: "请输入销售大区编号",

          SystemCode: "U053224",

          HomeUrl: "/YslCm",
          WorkBenchUrl: "/YslCm/SalesArea/WorkBench",
          BindWechatUrl: "/YslCm/PassageUser/BindWechat"
        }
      ]
    };
  },
  mounted() {},
  methods: {
    go_page(url) {
      this.$router.push(url);
    },

    async loadPassageUserWorkBench(systemCode, url) {
      var result = await passageUserManager.asyncGetMockPassageUserBySystemCode(
        systemCode
      );
      if (result.state == 1) {
        passageUserManager.clearSessionPassageUserData();
        var workBench = await passageUserManager.asyncGetPassageUserWorkBench();
        if (workBench) {
          passageUserManager.setSessionPassageUserWorkBench(workBench);
          console.log("appBox.passageUser-workbench", workBench);

          var passageUser = this.$appBox.getPassageUser();
          var workBenchUrl = url + "?uOpenId=" + passageUser.BusinessUnitOpenId;
          console.log("workBenchUrl", workBenchUrl);
          this.$router.push(workBenchUrl);
          //window.open(url, '_blank');
        }
      } else {
        alert("找不到身份信息:" + result.msg);
      }
    },

    async loadMemberUserWorkBench(systemCode, url) {
      var result = await memberUserManager.asyncGetMockMemberUserBySystemCode(
        systemCode
      );
      if (result.state == 1) {
        memberUserManager.clearSessionMemberUserData();
        var workBench = await memberUserManager.asyncGetMemberUserWorkBench();
        if (workBench) {
          memberUserManager.setSessionMemberUserWorkBench(workBench);
          console.log("appBox.memberUser-workbench", workBench);
          var memberUser = this.$appBox.getMemberUser();
          var workBenchUrl = url + "?bdOpenId=" + memberUser.BrandOpenId;
          this.$router.push(workBenchUrl);
          //window.open(url, '_blank');
        }
      } else {
        alert("找不到身份信息:" + result.msg);
      }
    },

    async onClickPassageUserWorkbench(userItem) {
      console.log(userItem, "内容------");
      var systemCode = userItem.SystemCode;
      var url = userItem.WorkBenchUrl;
      this.loadPassageUserWorkBench(systemCode, url);
    },

    async onClickPassageUserBinding(userItem) {
      var url = userItem.BindWechatUrl;
      this.$router.push(url);
    },

    async onClickPassageUserHome(userItem) {
      var url = userItem.HomeUrl;
      this.$router.push(url);
    },

    async onClickMemberUserWorkbench(userItem) {
      var systemCode = userItem.SystemCode;
      var url = userItem.WorkBenchUrl;
      this.loadMemberUserWorkBench(systemCode, url);
    },

    async onClickMemberUserBinding(userItem) {
      var url = userItem.BindWechatUrl;
      this.$router.push(url);
    },

    async onClickMemberUserHome(userItem) {
      var url = userItem.HomeUrl;
      this.$router.push(url);
    },

    async onClick(menuItem) {
      // var result = await get();
      // if (result.state == 1) {
      //   this.$router.push(menuItem.Url);
      // }
    }
  }
};
